import { html, LitElement, css} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import { voyageCursorStyles } from '../../voyage-style/src/voyage-style';

import { SvgIcons } from '../../voyage-svg-icons/src/voyage-svg-icons';
import { PlanChangedEvent, VesselPlanningModel } from '../../../src/models/vessel-planning-model';
import { VoyagePlansModel } from '../../../src/models/voyage-plans-model';
import { TraceService, EVENT_CATEGORIES } from '../../../src/services/trace-service';
import './voyage-time-slider';
import './voyage-time-popup-control';
import './voyage-time-scale-control';
import './time-slider';
import { VoyageRoute } from '../../../src/models/voyage-routing-model';
import "@maersk-global/mds-components-core/mc-select";
import { SliderComponent } from './time-slider';
import { DEFAULT_PLAYBACK, getFormattedDateTime } from '../../../src/utils/helpers';
import { VoyageShoreContextModel } from '../../../src/models/voyage-shore-context-model';
import { ShoreContextEvent } from '../../../src/models/types/voyage-shore-context-model.types';
import { UiStateModel, UiStateModelParam } from '../../../src/models/ui-state-model';

interface Waypoint
{
    timestamp: number;
}

function isVessel() {
    return (<any>window)["appenv"].vesselIMONumber !== undefined;
}

@customElement("voyage-time-control")
export class VoyageTimeControl extends LitElement {

    @property({type: Boolean}) isPlaying: boolean = false;
    @property({type: Number}) playerTime: number = -1;
    @property({type: Boolean}) showSpeedSelection: boolean = false;
    @property({type: Boolean}) showScaleSelection: boolean = false;
    @property({type: Number}) playbackRate: number = 1800;
    @property({type: Number}) timescale: number = 0;
    @property({type: String}) mode: string = "";
    @property({type: Number}) playbackSpeed: number = 1;
    @property({type: Number}) interval: number = 1;
    @property({type: Number}) duration: number = 7;
    @property({type: Boolean}) disableBackwardStep: boolean = false;
    @property({type: Boolean}) disableForwardStep: boolean = false;
    @property({type: Boolean}) disablePlayer: boolean = false;


    private playbackSpeeds = [0.5, 1.0, 1.5, 2.0, 2.5];
    private intervals = [1, 3, 6, 12, 24];
    private durations = [1, 2, 3, 4, 5, 6, 7];

    constructor() {
        super();
        this._imo = (<any>window)["appenv"].vesselIMONumber || 0;

        this._onPlanChanged = this._onPlanChanged.bind(this);
        this._onExecutingPlanChanged = this._onExecutingPlanChanged.bind(this);
        this._onPlansModelUpdated = this._onPlansModelUpdated.bind(this);
        this.renderPlayerControls = this.renderPlayerControls.bind(this);
        this.renderMcOption = this.renderMcOption.bind(this);
        this.handleSliderInput = this.handleSliderInput.bind(this);

        if((!UiStateModel?.getValue(UiStateModelParam.IMO) ? true : false) && UiStateModel?.getValue(UiStateModelParam.Search) ? true : false){
            this.toggleStep("backward", true);
        }
    }

    get planningScheduleId() {
        return this._planningScheduleId;
    }

    set planningScheduleId(value) {
        this._planningScheduleId = value;
        this._initPlans();
    }

    get imo() {
        return this._imo;
    }

    set imo(value) {
        this._imo = value;
        this._initPlans();
    }

    static get styles() {
        return [
            voyageCursorStyles,
            css`
                :host {
                    margin:0;
                    -webkit-user-select: none;
                    -moz-user-select: none;
                    user-select: none;
                }

                .container {
                    position: relative;
                    display: none;
                    flex-direction: row;
                    align-items: center;
                    background: var(--timeline-bg-color, black);
                    height: 100%;
                    width: 100%;
                }

                button {
                    box-sizing: border-box;
                    display: block;
                    background: var(--timeline-fg-color, white);
                    border: 1px solid var(--neutrals-grey-06, grey);
                    border-radius: 3px;
                    height: 33px;
                    width: 33px;
                    outline: none;
                    padding: 0;
                    font-family: MaerskText;
                    font-size: 14px;
                    color: var(--timeline-bg-color, black);
                }

                button:disabled {
                    opacity: 0.3;
                }

                button[selected] {
                    background: var(--timeline-button-selected-color, grey);
                }

                button > svg {
                    display: block;
                    fill: currentColor;
                    width: 16px;
                    margin: auto;
                }

                #playpause {
                    width: 41px;
                    height: 41px;
                }

                #stepBack {
                    margin-left: 12px;
                    border-radius: 3px 0 0 3px;
                }

                #stepForward {
                    border-radius: 0 3px 3px 0;
                }

                .stepButton > svg {
                    height: 14px;
                }

                #speed {
                    margin-left: 20px;
                }

                #scale {
                    margin-left: 20px;
                    margin-right: 20px;
                }

                #timeslider {
                    height: 100%;
                    flex-grow: 1;
                    border-left: 3px solid var(--timeline-divider-color, grey);
                }

                #speedSelection {
                    position: absolute;
                    bottom: 65px;
                    left: 95px;
                }

                .speedButton {
                    background: var(--neutrals-grey-10, white);
                    color: var(--neutrals-grey-02, black);
                    box-sizing: border-box;
                    border: none;
                    border-radius: 0;
                    height: 31px;
                    width: 39px;
                    overflow: hidden;
                    line-height: 10px;
                }

                .speedButton[selected] {
                    background: var(--neutrals-grey-07, grey);
                }

                .speedButton:first-child {
                    border-right: 1px solid var(--neutrals-grey-06, grey);
                }

                .speedButton:last-child {
                    border-left: 1px solid var(--neutrals-grey-06, grey);
                }

                .unitText {
                    font-size: 10px;
                }

                #scaleSelection {
                    position: absolute;
                    bottom: 65px;
                    left: 165px;
                }
                .playback-speed-container{
                    width: 190px;
                }
                .interval-container{
                    width: 140px;
                }
                .interval-container mc-select::part(label-container) {
                    display: flex;
                    justify-content: flex-end;
                    width: 80px;
                    position: relative;
                    top: 3px;
                }
                .duration-container{
                    width: 180px;
                }
                .mc-input .container{
                    width: 80px;
                }
                .separator{
                    border-left: 1px solid #D2D2D2;
                    padding: 13px 0;
                }
                .button-separator{
                    border-left: 1px solid #D2D2D2;
                    padding: 6px 0 2px 0;
                }
                #play-pause svg{
                    width: 16px;
                    height: 14px;
                }
                .action-items{
                    border: 1px solid #D2D2D2;
                    border-radius: 5px;
                    margin-right: 10px;
                }
                .time-container{
                    margin: 0 10px;
                    font-family: Maersk Text;
                    font-size: 12px;
                    font-weight: 700;
                    line-height: 16px;
                    text-align: left;
                }
                .reset-button{
                    padding: 0 2px;
                }
                .w-110{
                    width: 110%;
                }
                .dib{
                  display: inline-block;  
                }
                .player-controls{
                    border: 1px solid rgb(210, 210, 210);
                    border-radius: 5px 5px 0px 0px;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;
                    background: var(--neutrals-grey-10, #FFFFFF);
                    height: 100%;
                    padding: 5px 0;
                    width: 80%;
                    position: relative;
                    margin: auto;
                    bottom: 32px;
                }
                mc-select::part(label-container) {
                    display: flex;
                    justify-content: flex-end;
                    width: 120px;
                    position: relative;
                    top: 3px;
                }
                .player-container{
                    position: relative;
                    bottom: 60px;
                    width: 90%;
                    margin: auto;
                    z-index: 3;
                }
        `];
    }

    render() {
        this._updateWaypointIndeces();

        return html`
        <div class="player-container">
            ${html`${this.renderPlayerControls()}`}
            <div class="time-control">
                <voyage-time-slider-control 
                    id="voyage-time-slider-control"
                    .duration="${this.duration}" 
                    .interval="${this.interval}" 
                    .playback="${this.playbackSpeed}"
                    .disablePlayer="${this.disablePlayer}"
                    @timeline-complete="${(evt: CustomEvent) => this._togglePlay()}"
                    @slider-input="${(evt: CustomEvent) => this.handleSliderInput(evt)}">
                </voyage-time-slider-control>
            </div>
        </div>
        <div class="container">
            <button id="stepBack" class="stepButton" ?disabled=${this._prevWaypointIndex === -1} @click=${this._stepBack}>
                ${SvgIcons.stepBackward}
            </button>
            <button class="playcontrol" id="playpause" @click=${this._togglePlay}>
                ${this.isPlaying ? SvgIcons.pause : SvgIcons.play}
            </button>
            <button id="stepForward" class="stepButton" ?disabled=${this._nextWaypointIndex === -1} @click=${this._stepForward}>
                ${SvgIcons.stepForward}
            </button>

            <button id="speed" ?selected=${this.showSpeedSelection} @click=${this._toggleSpeedSelector}>
                ${this.playbackRate === 1800 ? SvgIcons.lightTachometerSlow :
                                               this.playbackRate === 3600 ? SvgIcons.lightTachometerAverage : SvgIcons.lightTachometerFast}
            </button>

            <button id="scale" ?selected=${this.showScaleSelection} @click=${this._toggleScaleSelector}>
                ${SvgIcons.lightArrowsH}
            </button>

            <voyage-time-slider id="timeslider" .mode=${this.mode} .planningScheduleId=${this.planningScheduleId} .scale=${this.timescale} .focusTime=${this.playerTime}></voyage-time-slider>

            ${this.showSpeedSelection ? html`
            <voyage-time-popup-control id="speedSelection" ?darkarrow=${this.playbackRate === 3600}>
                <button ?selected=${this.playbackRate === 1800} class="speedButton" @click=${() => this._speedClicked(1800)}>
                    30 <span class="unitText">min/s</span>
                </button>
                <button ?selected=${this.playbackRate === 3600} class="speedButton" @click=${() => this._speedClicked(3600)}>
                    60 <span class="unitText">min/s</span>
                </button>
                <button ?selected=${this.playbackRate === 14400} class="speedButton" @click=${() => this._speedClicked(14400)}>
                    240 <span class="unitText">min/s</span>
                </button>
            </voyage-time-popup-control>` : ""}

            ${this.showScaleSelection ? html`
            <voyage-time-popup-control id="scaleSelection">
                <voyage-time-scale-control .selection=${this.timescale}
                                           @selection-changed=${ (evt: CustomEvent) => this.timescale = evt.detail }>
                </voyage-time-scale-control>
            </voyage-time-popup-control>` : ""}
        </div>
        `;
    }

    connectedCallback() {
        super.connectedCallback();

        if (isVessel()) {
            VesselPlanningModel!.addEventListener("plan-changed", <EventListener>this._onPlanChanged);
            VesselPlanningModel!.addEventListener("executing-plan-changed", this._onExecutingPlanChanged);
        } else {
            VoyagePlansModel!.addEventListener('plans-updated', <EventListener>this._onPlansModelUpdated);
        }

        this._initPlans();
        VoyageShoreContextModel?.addEventListener('toggle-vessel-selection', () => {
            this.isPlaying = false;
            this.dispatchEvent(new CustomEvent('toggle-play', {detail: { play: this.isPlaying }}));
            let timeSlider = <SliderComponent>this.shadowRoot?.querySelector("#voyage-time-slider-control");
            timeSlider?.togglePlay(this.isPlaying);
            this._reset();
            this.toggleStep("backward", false);
        });
        VoyageShoreContextModel!.addEventListener(ShoreContextEvent.TimeLineViewToggle, this._reset);
    }

    disconnectedCallback() {
        super.disconnectedCallback();

        if (isVessel()) {
            VesselPlanningModel!.removeEventListener("plan-changed", <EventListener>this._onPlanChanged);
            VesselPlanningModel!.removeEventListener("executing-plan-changed", this._onExecutingPlanChanged);
        } else {
            VoyagePlansModel!.removeEventListener('plans-updated', <EventListener>this._onPlansModelUpdated);
        }

        if (this._updateWPIndecesTimer) {
            clearTimeout(this._updateWPIndecesTimer);
        }
        VoyageShoreContextModel?.removeEventListener('toggle-vessel-selection', () => {
            this.isPlaying = false;
            this.dispatchEvent(new CustomEvent('toggle-play', {detail: { play: this.isPlaying }}));
            let timeSlider = <SliderComponent>this.shadowRoot?.querySelector("#voyage-time-slider-control");
            timeSlider?.togglePlay(this.isPlaying);
            this._reset();
            this.toggleStep("backward", false);
        });
        VoyageShoreContextModel!.removeEventListener(ShoreContextEvent.TimeLineViewToggle, this._reset);
    }

    @property({ attribute: false }) private _nextWaypointIndex: number = -1;
    @property({ attribute: false }) private _prevWaypointIndex: number = -1;
    @property({ attribute: false }) private _planningScheduleId: string = "";
    private _imo: number;
    private _waypoints: Waypoint[] = [];
    private _updateWPIndecesTimer: number = 0;

    private _togglePlay() {
        this.isPlaying = !this.isPlaying;
        TraceService!.event(EVENT_CATEGORIES.TIME_CONTROL, 'click', 'Play/Pause toggled');
        let timeSlider = <SliderComponent>this.shadowRoot?.querySelector("#voyage-time-slider-control");

        // Fast forward to first waypoint if we have one (and it is not in the past)
        let now = new Date();
        now.setHours(now.getHours() + timeSlider?.getProgressValue());
        this.dispatchEvent(new CustomEvent('focustime-update', {
            detail: { focustime: now },
            bubbles: true,
            composed: true
        }));

        this.dispatchEvent(new CustomEvent('toggle-play', {detail: { play: this.isPlaying }}));
        timeSlider?.togglePlay(this.isPlaying);
        this.toggleStep("backward", false);
    }

    private _stepBack() {
        TraceService!.event(EVENT_CATEGORIES.TIME_CONTROL, 'click', 'Step backward');
        let timeSlider = <SliderComponent>this.shadowRoot?.querySelector("#voyage-time-slider-control");
        timeSlider?.step("backward");
    }

    private _stepForward() {
        TraceService!.event(EVENT_CATEGORIES.TIME_CONTROL, 'click', 'Step forward');
        let timeSlider = <SliderComponent>this.shadowRoot?.querySelector("#voyage-time-slider-control");
        timeSlider?.step("forward");
        this.toggleStep("backward", false);
    }

    private _toggleSpeedSelector() {
        TraceService!.event(EVENT_CATEGORIES.TIME_CONTROL, 'click', 'Speed selector toggled');

        this.showScaleSelection = false;
        this.showSpeedSelection = !this.showSpeedSelection;
    }

    private _toggleScaleSelector() {
        TraceService!.event(EVENT_CATEGORIES.TIME_CONTROL, 'click', 'Scale selector toggled');

        this.showSpeedSelection = false;
        this.showScaleSelection = !this.showScaleSelection;
    }

    private _speedClicked(speed: number) {
        this.playbackRate = speed;
        this.dispatchEvent(new CustomEvent('playbackrate-update', { detail: { playbackrate: speed } }));
        this.showSpeedSelection = false;

        TraceService!.event(EVENT_CATEGORIES.TIME_CONTROL, 'change', 'Playback speed changed', speed);
    }

    private async _initPlans() {
        if (isVessel()) {
            const executingPlan = await VesselPlanningModel!.getExecutingPlan();
            let planningPlan = null;

            if (this._planningScheduleId) {
                const plan = await VesselPlanningModel!.getCurrentPlan(this._planningScheduleId);
                if (plan && plan.selectedRouteIndex >= 0 && plan.routes[plan.selectedRouteIndex]) {
                    planningPlan = plan;
                }
            }

            this._waypoints = [];
            if (executingPlan) {
                this._waypoints = this._getWaypoints(executingPlan.routes[executingPlan.selectedRouteIndex], executingPlan.etd);
            }
            if (planningPlan) {
                this._waypoints = this._waypoints.concat(this._getWaypoints(planningPlan.routes[planningPlan.selectedRouteIndex], planningPlan.etd));
            }

        } else {
            // Shore
            const plan = VoyagePlansModel!.choosePlan(this._imo);
            if (plan && plan.routes.length > 0) {
                this._waypoints = this._getWaypoints(plan.routes[plan.selectedRouteIndex], plan.etd)
            } else {
                this._waypoints = [];
            }
        }

        this._updateWaypointIndeces();
    }

    private _onPlanChanged(evt: PlanChangedEvent) {
        if (evt.detail.scheduleId === this._planningScheduleId) {
            this._initPlans();
        }
    }

    private _onExecutingPlanChanged() {
        this._initPlans();
    }

    private _onPlansModelUpdated(evt: CustomEvent) {
        if (evt.detail.imoNo === this._imo) {
            this._initPlans();
        }
    }

    private _getWaypoints(route: VoyageRoute, planEtd: number) {
        return route.route_geometry.filter( feature => feature.geometry.type === "Point" ).map( point => {

            // Note: First waypoint in a route does not have a timestamp, use planEtd in this case
            return {
                timestamp: new Date(point.properties.timestamp || planEtd).getTime()
            }
        });
    }

    private _updateWaypointIndeces() {
        if (this._waypoints.length === 0) {
            this._nextWaypointIndex = -1;
            this._prevWaypointIndex = -1;
            if (this._updateWPIndecesTimer) {
                clearTimeout(this._updateWPIndecesTimer);
                this._updateWPIndecesTimer = 0;
            }
            return;
        }

        const currentTime = Math.max(this.playerTime, Date.now());

        // Start search at current previous waypoint (if any)
        let startIdx = Math.max(0, this._prevWaypointIndex);
        if (startIdx > 0 && currentTime < this._waypoints[startIdx].timestamp) {
            // Time was set backwards - start from index 0
            startIdx = 0;
        }

        // Find first waypoint past currentTime
        let i = startIdx;
        while (i < this._waypoints.length && this._waypoints[i].timestamp <= currentTime) {
            i++;
        }
        this._nextWaypointIndex = i === this._waypoints.length ? -1 : i;
        this._prevWaypointIndex = i === 0 ? -1 : this._waypoints[i-1].timestamp === currentTime ? i-2 : i-1;

        // Don't allow going backwards in time
        if (this._prevWaypointIndex !== -1 && this._waypoints[this._prevWaypointIndex].timestamp < Date.now()) {
            this._prevWaypointIndex = -1;
        }
        if (this._nextWaypointIndex !== -1 && this._waypoints[this._nextWaypointIndex].timestamp < Date.now()) {
            this._nextWaypointIndex = -1;
        }

        // Keep indeces updated as time passes
        if (this._updateWPIndecesTimer) {
            clearTimeout(this._updateWPIndecesTimer);
        }
        this._updateWPIndecesTimer = window.setTimeout(() => this._updateWaypointIndeces(), 1000);
    }

    renderPlayerControls(){
        return html`<div class="player-controls">
                <span class="action-items">
                    <span class="dib">
                        <mc-button
                            class="w-110"
                            width="full-width"
                            fit="small"
                            variant="plain"
                            appearance="neutral"
                            ?disabled="${this.disableBackwardStep || this.disablePlayer}"
                            @click=${this._stepBack}
                        >${SvgIcons.arrowAntiClockwise}</mc-button>
                    </span>
                    <span class="button-separator"></span>
                    <span class="dib">
                        <mc-button
                            class="w-110"
                            id="play-pause"
                            width="full-width"
                            fit="small"
                            variant="plain"
                            appearance="neutral"
                            ?disabled="${this.disablePlayer}"
                            @click=${this._togglePlay}>
                            ${this.isPlaying ? SvgIcons.pause : SvgIcons.playTimeline}
                        </mc-button>
                    </span>
                    <span class="button-separator"></span>
                    <span class="dib">
                        <mc-button
                            width="full-width"
                            fit="small"
                            variant="plain"
                            appearance="neutral"
                            ?disabled="${this.disableForwardStep || this.disablePlayer}"
                            @click=${this._stepForward}
                        >${SvgIcons.arrowClockwise}</mc-button>   
                    </span>
                </span>
                <span class="separator"></span>
                <mc-button
                    class="reset-button"
                    fit="small"
                    variant="plain"
                    padding="compact"
                    appearance="neutral"
                    ?disabled="${this.disablePlayer}"
                    @click=${this._reset}
                >${SvgIcons.reset}
                </mc-button>
                
                <span class="separator"></span>
                <span class="time-container">${getFormattedDateTime(new Date())}</span>
                <span class="separator"></span>
                
                <span class="playback-speed-container">
                    <mc-select label="Playback speed"
                        optionswidth="80px"
                        name="playback-speed"
                        fit="small"
                        labelposition="left"
                        value="1"
                        id="playback-speed-controller"
                        ?disabled="${this.disablePlayer}"
                        @input={yourEventHandler(e)}
                        @click={yourEventHandler(e)}
                        @clearbuttonclick={yourEventHandler(e)}
                        @optionselected=${(e: CustomEvent) => this.handlePlayBackSpeedChange(e)}
                        @opened={yourEventHandler(e)}
                        @closed={yourEventHandler(e)}>
                        ${this.playbackSpeeds.map((speed: any) => {
                            return html `${this.renderMcOption(speed, speed.toFixed(1) + " x")}`
                        })}
                    </mc-select>
                </span>
                <span class="interval-container">
                    <mc-select label="Interval"
                    optionswidth="80px"
                        name="interval"
                        fit="small"
                        labelposition="left"
                        value="1"
                        id="interval-controller"
                        ?disabled="${this.disablePlayer}"
                        @input={yourEventHandler(e)}
                        @click={yourEventHandler(e)}
                        @clearbuttonclick={yourEventHandler(e)}
                        @optionselected=${(e: CustomEvent) => this.handleIntervalChange(e)}
                        @opened={yourEventHandler(e)}
                        @closed={yourEventHandler(e)}>
                        ${this.intervals.map(interval => {
                            return html `${this.renderMcOption(interval, interval + " h")}`;
                        })}
                    </mc-select>
                </span>
                <span class="duration-container">
                    <mc-select label="Duration (day)"
                    optionswidth="80px"
                        name="duration"
                        fit="small"
                        labelposition="left"
                        value="7"
                        id="duration-controller"
                        ?disabled="${this.disablePlayer}"
                        @input={yourEventHandler(e)}
                        @click={yourEventHandler(e)}
                        @clearbuttonclick={yourEventHandler(e)}
                        @optionselected=${(e: CustomEvent) => this.handleDurationChange(e)}
                        @opened={yourEventHandler(e)}
                        @closed={yourEventHandler(e)}>
                        ${this.durations.map(duration => {
                            return html `${this.renderMcOption(duration, duration + " d")}`;
                        })}
                    </mc-select>
                </span>
            </div>`;
    }

    renderMcOption(value: number, label: string){
        return html `<mc-option value="${value}">${label}</mc-option>`;
    }

    handlePlayBackSpeedChange(event: CustomEvent){
        this.playbackSpeed = event?.detail?.value || 1;
        this.dispatchEvent(new CustomEvent('playbackrate-update', { detail: { playbackrate: this.playbackSpeed*DEFAULT_PLAYBACK*this.interval } }));
    }

    handleIntervalChange(event: CustomEvent){
        this.interval = event?.detail?.value || 1;
        this.dispatchEvent(new CustomEvent('playbackrate-update', { detail: { playbackrate: this.playbackSpeed*DEFAULT_PLAYBACK*this.interval } }));
    }

    handleDurationChange(event: CustomEvent){
        this.duration = event?.detail?.value || 7;        
    }

    _reset() {
        let timeSlider = <SliderComponent>this.shadowRoot?.querySelector("#voyage-time-slider-control");
        timeSlider?.reset();
        this.dispatchEvent(new CustomEvent('focustime-update', {
            detail: { focustime: Date.now() },
            bubbles: true,
            composed: true
        }));
    }

    private handleSliderInput(event: CustomEvent){
        this.dispatchEvent(new CustomEvent('focustime-update', {
            detail: { focustime: event.detail.focustime },
            bubbles: true,
            composed: true
        }));
        this.toggleStep("backward", false);
    }

    toggleStep(direction: string, disable: boolean){
        if(direction === 'forward'){
            this.disableForwardStep = disable;
        }
        if(direction === 'backward'){
            this.disableBackwardStep = disable;
        }
    }

    togglePlayerControls(disable: boolean){
        this.disablePlayer = disable;
    }
}
